function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

var Story = function Story(_ref) {
  var children = _ref.children,
      className = _ref.className,
      pageWidth = _ref.pageWidth,
      spacing = _ref.spacing;
  var classNames = classnames(_defineProperty({
    'wfp--story': true
  }, "".concat(className), className));
  return React.createElement("div", {
    className: classNames,
    pageWidth: pageWidth ? pageWidth : 'md',
    spacing: spacing
  }, children);
};

Story.propTypes = {
  /**
    The Story content
  */
  children: PropTypes.node,

  /**
    Additional className for Story
  */
  className: PropTypes.string
};
export default Story;